"use strict";

(function () {
  const DESKTOP_MQ = "(min-width: 992px)";

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function getActiveIndex(gallery) {
    const checked = gallery.querySelector(".product-media-rebuilt-radio:checked");
    if (!checked || !checked.id) return 0;
    const m = checked.id.match(/-(\d+)$/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function updateThumbVarsFromBaseline(gallery) {
    // Use a stable baseline height (first image) to avoid layout jumps when switching images.
    const baselineImg =
      gallery.querySelector('.product-media-rebuilt-main-item[data-index="0"] img.product-media-rebuilt-main-image') ||
      gallery.querySelector("img.product-media-rebuilt-main-image");

    if (!baselineImg) return;

    const rect = baselineImg.getBoundingClientRect();
    const h = rect.height;
    if (!h || h < 10) return;

    const gap = parseFloat(getComputedStyle(gallery).getPropertyValue("--thumb-gap")) || 6;
    const rail = Math.round(h);
    const thumb = Math.max(48, Math.floor((rail - (gap * 2)) / 3));
    const col = clamp(Math.round(thumb * 0.75), 84, 140);

    gallery.style.setProperty("--thumb-rail-height", `${rail}px`);
    gallery.style.setProperty("--thumb-size", `${thumb}px`);
    gallery.style.setProperty("--thumb-col", `${col}px`);
  }

  function getStepPx(root) {
    const scroller = root.querySelector(".product-media-rebuilt-thumbs-scroll");
    const firstThumb = scroller?.querySelector(".product-media-rebuilt-thumb");
    if (!scroller || !firstThumb) return 126;

    const gap = parseFloat(getComputedStyle(scroller).rowGap || "0") || 0;
    const h = firstThumb.getBoundingClientRect().height || 120;
    return Math.round(h + gap);
  }

  function bind(root = document) {
    if (!window.matchMedia || !window.matchMedia(DESKTOP_MQ).matches) return;

    root.querySelectorAll("[data-product-media-rebuilt]").forEach((gallery) => {
      const btnUp = gallery.querySelector("[data-thumbs-up]");
      const btnDown = gallery.querySelector("[data-thumbs-down]");
      const arrowsWrap = gallery.querySelector(".product-media-rebuilt-thumbs-arrows");
      const scroller = gallery.querySelector(".product-media-rebuilt-thumbs-scroll");
      if (!btnUp || !btnDown || !scroller || !arrowsWrap) return;

      let rafId = 0;
      const scheduleVars = () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          updateThumbVarsFromBaseline(gallery);
        });
      };

      const updateArrows = () => {
        const canScroll = scroller.scrollHeight > scroller.clientHeight + 2;
        arrowsWrap.style.display = canScroll ? "" : "none";
        btnUp.disabled = !canScroll || scroller.scrollTop <= 1;
        const maxTop = scroller.scrollHeight - scroller.clientHeight;
        btnDown.disabled = !canScroll || scroller.scrollTop >= maxTop - 1;
      };

      const scrollByStep = (dir) => {
        const step = getStepPx(gallery);
        scroller.scrollBy({ top: dir * step, behavior: "smooth" });
      };

      btnUp.addEventListener("click", () => scrollByStep(-1));
      btnDown.addEventListener("click", () => scrollByStep(1));

      scroller.addEventListener("scroll", updateArrows, { passive: true });
      window.addEventListener("resize", () => {
        scheduleVars();
        updateArrows();
      }, { passive: true });

      gallery.addEventListener("change", () => {
        // Do NOT rescale on image change (prevents glitches). Only arrow state changes.
        updateArrows();
      });

      // Update when images finish loading (first render + swaps)
      gallery.querySelectorAll("img.product-media-rebuilt-main-image").forEach((img) => {
        if (img.complete) return;
        img.addEventListener("load", () => {
          scheduleVars();
          updateArrows();
        }, { once: true });
      });

      scheduleVars();
      updateArrows();
    });
  }

  document.addEventListener("DOMContentLoaded", () => bind());
  document.addEventListener("shopify:section:load", (e) => bind(e.target));
})();

